module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_ADAPTED_STYLE.d2ce1e41.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_ADAPTED_STYLE.png
// module id = 1273
// module chunks = 16